import _ from 'lodash'
import * as Sentry from '@sentry/vue'
import EventBus from '@/eventBus'
import Constants from '@/constant'
import store from '@/vuex/store'

import Socket from '@/socket'
import socketHelper from '@/helpers/socket/socket-helper'

// configs
import Config from '@/config'

// utils
import Utils from '@/util'

const CREATE_REACTION = 'create-reaction'

export default {
  initSocket(channel, editor) {
    Socket.subscribe(`${channel}-presenter`, (doc) => {
      this.initSocketHandler(doc, editor)
    })
  },

  initSocketHandler(doc, editor) {
    if (doc.socketId == Socket.getSocketId()) {
      return
    }
    if (doc.t === 'account-removal') {
      window.location.href = Config.accountRemovalURL
      return
    }

    if (doc.type == 'uO') {
      this._handleUserOnlineCount(editor, doc)
      return
    }

    let index
    const { presentation } = editor.$store.state

    // handle socket msg answer quiz, poll from audience
    if (doc.t == 'a') {
      // editor._checkAndUpdateHasResults()
      let indexSlideVote = null

      if (doc.s != editor.slideActive.id) {
        const indexSlideInPresentation = editor.presentation.slides.findIndex((item) => {
          return item.id == doc.s
        })

        if (indexSlideInPresentation !== -1) {
          indexSlideVote = indexSlideInPresentation
        }
      }

      if (doc.iTa) {
        this._resetTempAudienceCount(editor, doc)
        if (indexSlideVote === null) {
          editor.$store.state.tempAudienceCount++
          this.updateVoteCountThrottle(editor, doc, null)
        } else {
          editor.$store.state.presentation.slides[indexSlideVote].voteCache++
          this.updateVoteCountThrottle(editor, doc, indexSlideVote)
        }

        return
      }

      if (doc.v && doc.v.length) {
        this._resetTempAudienceCount(editor, doc)

        if (indexSlideVote === null) {
          editor.$store.state.tempAudienceCount++
          this.updateVoteCountThrottle(editor, doc, null)
        } else {
          editor.$store.state.presentation.slides[indexSlideVote].voteCache++

          this.updateVoteCountThrottle(editor, doc, indexSlideVote)
        }

        this._updateSlideOptions(editor, doc)
        if (editor.presentation.audiencePacing) {
          // update chart whenever audience answers
          editor.$store.dispatch('updateSlideActive', editor.slideActive)
        }
      }

      return
    }

    if (doc.type == 'question-and-answer') {
      if (doc.action == 'create') {
        // editor._checkAndUpdateHasResults()
        if (!editor.presentation.isModerationMode) {
          const arr = JSON.parse(JSON.stringify(editor.$store.state.questions))
          arr.push(doc.data)
          Utils.updateDataQuestionAnswer(arr, editor.$store.state.tabQnaQuestion)
          EventBus.$emit('questionAnimationAction')
        } else {
          editor.$store.state.questions.push(doc.data)
        }
        Utils.mixpanelTracking('Question And Answer', 'Question Received', 'Question Received')
      } else if (doc.action == 'vote' || doc.action === 'question-updated') {
        this._updateQuestionAnswer(editor, doc.data)
      }
    }

    // using both channel
    if (doc.type == 'slide' && doc.data.id == editor.slideActive.id) {
      const { data } = doc

      const payload = {
        type: doc.type,
        layout: doc.layout,
        multipleChoice: data.multipleChoice,
        limitChoice: data.limitChoice,
        typeChart: data.typeChart || 'barChart',
        hideResult: data.hideResult,
        addCorrectOption: data.addCorrectOption,
        stopSubmission: data.stopSubmission,
        showAllBulletPoints: data.showAllBulletPoints,
        image: data.image,
        imageCaption: data.imageCaption,
        youtubeLink: data.youtubeLink,
        backgroundImage: data.backgroundImage,
        textColour: data.textColour,
        baseColour: data.baseColour,
        visibility: data.visibility,
        showQuestionImage: data.showQuestionImage,
      }

      editor.updateSlideActiveAction(payload)
    }

    if (doc.type == 'presentation') {
      if (doc.action == 'uniqueAccessCode') {
        editor.$store.state.presentation.qrcode = doc.data.qrcode
        editor.$store.state.presentation.uniqueAccessCode =
              doc.data.uniqueAccessCode
        editor.$store.state.presentation.shareCode = doc.data.shareCode
      }

      if (doc.action == 'changeAccessCode') {
        editor.$store.state.presentation.accessCode = doc.data.accessCode
      }

      if (doc.action === 'update-canvas-blocks' && doc.data && doc.data.canvasBlocks) {
        editor.updateSlideByIdAction({
          id: doc.data.slideId,
          canvasBlocks: doc.data.canvasBlocks,
          canvasBlocksUrl: doc.data.canvasBlocksUrl,
        })
      }

      if (doc.action == 'privateMode') {
        editor.$store.state.presentation.privateMode = doc.data.presentation.privateMode
      }

      if (doc.action === 'presentation-update' && doc.socketId !== Socket.getSocketId()) {
        const newPayload = {}
        Object.keys(doc.data).forEach((key) => {
          const oldValue = doc.data[key]
          let newValue = oldValue
          if (typeof oldValue === 'string') {
            if (oldValue === 'true') {
              newValue = true
            }
            if (oldValue === 'false') {
              newValue = false
            }
          }
          newPayload[key] = newValue
        })
        editor.$store.dispatch('updatePresentation', newPayload)
      }
    }

    if (doc.type === 'user-online-count') {
      if (doc.data || doc.data === 0) {
        if (doc.data > editor.userOnline) {
          EventBus.$emit('userOnlineCount')
        }

        editor.onlineCount = doc.data
        this._handleOnlineCountThrottled(editor)
        if (!editor.maxOnlineCount || editor.onlineCount > editor.maxOnlineCount) {
          editor.maxOnlineCount = editor.onlineCount
        }
      }
    }

    if (doc.type == 'slideOption' && doc.action == 'audience-create') {
      // editor._checkAndUpdateHasResults()
      if (editor.slideActive.type === 'openEnded') {
        if (editor.slideActive.id === doc.data.slideId) {
          EventBus.$emit('new-open-ended-response', doc.data)
        }

        return
      }

      const matchSlide = editor.presentation.slides.find((slide) => slide.id === doc.data.slideId)
      if (!matchSlide) return

      const newSlideOptions = [...matchSlide.SlideOptions, doc.data]
      editor.patchSlideByIdAction({
        id: doc.data.slideId,
        SlideOptions: newSlideOptions,
      })
    }

    if (
      doc.type == 'slideWordCloud' &&
          doc.action == 'audience-wordcloud'
    ) {
      // editor._checkAndUpdateHasResults()
      if (doc.data.slideId == editor.slideActive.id) {
        const newSlideOptions = editor.slideActive.SlideOptions.concat(doc.data.options)
        editor.updateSlideActiveAction({
          SlideOptions: newSlideOptions,
        })

        EventBus.$emit('audienceWordCloud')
      } else {
        index = Utils.getIndexSlide(presentation.slides, doc.data.slideId)
        if (index != -1) {
          presentation.slides[index].SlideOptions = presentation.slides[
            index
          ].SlideOptions.concat(doc.data.options)
        }
      }
    }

    if (doc.type === 'quiz-show-answer' && editor.sharePresentation) {
      if (editor.slideActive.id === parseInt(doc.data.slideId, 10)) {
        EventBus.$emit('eventShowQuizTypeAnswer')
      }
      return
    }

    if (doc.type === 'aLQT') {
      this._handleChangeQuizTeam(editor, doc.data)
      EventBus.$emit('gamelobby-leave-team', doc.data)
    }

    if (doc.t === 'sca') {
      // editor._checkAndUpdateHasResults()
      this._resetTempAudienceCount(editor, doc)
      editor.$store.state.tempAudienceCount++
      this._handleAudienceScaleQuestionThrottled()
      this.updateVoteCountForScaleThrottle(editor)
    }
  },
  _resetTempAudienceCount(editor, doc) {
    if (!editor.slideActive.multipleCountAnswer) {
      if (editor.slideActive.id != doc.s) {
        Sentry.captureException(new Error('DEBUG AHA-19176: _resetTempAudienceCount: editor.slideActive.id different from doc.s'), {
          extra: {
            'slideActive.id': editor.slideActive.id,
            doc,
            tempAudienceCount: editor.$store.state.tempAudienceCount,
            multipleCountAnswer: editor.slideActive.multipleCountAnswer,
          },
        })
      } else {
        editor.updateSlideActiveAction({
          multipleCountAnswer: 0,
        })
        editor.$store.state.tempAudienceCount = 0
      }
    }
  },
  _handleUserOnlineCount(editor, socketData) {
    const doc = {
      data: {
        audience: socketData.data.a,
        audienceName: socketData.data.n,
        audienceEmoji: socketData.data.e,
        quizOnline: socketData.data.q,
        audienceTeam: socketData.data.t,
      },
    }
    if (socketData.i) {
      doc.data.data = {
        id: socketData.data.i,
        answer: socketData.data.r,
      }
    }

    const params = {
      audience: doc.data.audience,
      audienceEmoji: doc.data.audienceEmoji,
      audienceName: doc.data.audienceName,
      offline: doc.data.offline,
      audienceTeam: doc.data.audienceTeam,
    }

    const objAudience = editor.$store.state.audiences[params.audience]
    if (!objAudience) {
      editor.$store.state.audiences[params.audience] = params
    } else {
      if (objAudience.audienceName !== params.audienceName) {
        editor.$store.state.audiences[params.audience].audienceName = params.audienceName
      }
      if (objAudience.audienceEmoji !== params.audienceEmoji) {
        editor.$store.state.audiences[params.audience].audienceEmoji = params.audienceEmoji
      }
      if (objAudience.audienceTeam !== params.audienceTeam) {
        editor.$store.state.audiences[params.audience].audienceTeam = params.audienceTeam
      }
      if (objAudience.offline !== params.offline) {
        editor.$store.state.audiences[params.audience].offline = params.offline
      }

      if (doc.data.data) {
        if (
          editor.$store.state.audiences[params.audience][doc.data.data.id] !== true
        ) {
          editor.$store.state.audiences[params.audience][doc.data.data.id] = doc.data.data.answer
        }
      }
    }
  },

  _handleAudienceScaleQuestionThrottled: _.throttle(() => {
    EventBus.$emit('scaleQuestionAnswer')
  }, 1000),

  updateVoteCountForScaleThrottle: _.throttle((editor) => {
    editor.updateSlideActiveAction({
      multipleCountAnswer: editor.$store.state.tempAudienceCount,
    })
  }, 250),

  _updateQuestionAnswer(editor, question) {
    const index = editor.$store.state.questions.findIndex((item) => {
      return item.id == question.id
    })
    if (index === -1) {
      editor.$store.state.questions.push(question)
    } else {
      editor.$store.state.questions[index] = question
    }
    const arr = JSON.parse(JSON.stringify(editor.$store.state.questions))
    Utils.updateDataQuestionAnswer(arr, editor.$store.state.tabQnaQuestion)
  },

  _handleChangeQuizTeam(editor, data) {
    if (editor.$store.state.audiences[data.a]) {
      delete editor.$store.state.audiences[data.a]
    }
  },

  _handleOnlineCountThrottled: _.throttle((editor) => {
    editor.$store.state.userOnline = editor.onlineCount

    if (editor.$store.state.currentUser.id) {
      editor.$store.state.onlineStatus = 1
    }
  }, 1000),

  updateVoteCountThrottle: _.throttle((editor, doc, index) => {
    const { s: slideId } = doc
    const payload = {
      id: slideId,
      multipleCountAnswer: editor.$store.state.tempAudienceCount,
    }
    if (index !== null) {
      payload.multipleCountAnswer = editor.presentation.slides[index].voteCache
    }

    editor.patchSlideByIdAction(payload)
  }, 250),

  _updateSlideOptions(editor, doc) {
    const { s: slideId, v: votedSlideOptionIds } = doc

    const matchSlide = editor.presentation.slides.find((slide) => slide.id === slideId)
    if (!matchSlide) return

    const newSlideOptions = matchSlide.SlideOptions.map((slideOption) => {
      const hasVoted = votedSlideOptionIds.some((item) => item === slideOption.id)

      if (hasVoted) {
        const currentCount = slideOption.count || 0
        return {
          ...slideOption,
          count: currentCount + 1,
        }
      }

      return slideOption
    })

    editor.patchSlideByIdAction({
      id: slideId,
      SlideOptions: newSlideOptions,
    })
  },

  _checkEveryoneVotedQuiz(editor) {
    if (editor.$store.state.slideActive.type !== 'pickAnswer') {
      return
    }
    if (editor.$store.state.slideActive.quizStatus !== Constants.QuizStatuses.QUESTION_SCREEN) {
      return
    }

    let someoneHaveNotVote = false

    Object.keys(editor.$store.state.audiences).forEach((key) => {
      const audience = editor.$store.state.audiences[key]
      const audienceNotAnswer = !audience[editor.$store.state.slideActive.id]
      if (audienceNotAnswer) {
        someoneHaveNotVote = true
      }
    })
    if (!someoneHaveNotVote) {
      EventBus.$emit('everyone-voted')
    }
  },

  disconnectSocket(editor) {
    socketHelper.leaveRoomPresentation(editor.presentation.uniqueAccessCode)
    socketHelper.leaveRoomSlide(editor.presentation.uniqueAccessCode, editor.slideActive.id)

    Socket.getSocket().off('create-idea')
    Socket.getSocket().off('vote-idea')
    Socket.getSocket().io.off('reconnect')
    Socket.getSocket().off('add-slides')
    Socket.off(CREATE_REACTION)
    Socket.off('patch-presentation')
    Socket.getSocket().off('conversation-presenter-share')

    Socket.unSubscribe(editor.$store.state.presentation.uniqueAccessCode)
    Socket.unSubscribe(`${editor.$store.state.presentation.uniqueAccessCode}-presenter`)
    Socket.unSubscribe(`user-${editor.$store.state.currentUser.id}`)
  },

  handleSocketEvent(editor) {
    Socket.getSocket().on('create-idea', (doc) => this._handleAudienceCreateIdeaEvent(editor, doc))
    Socket.getSocket().on('vote-idea', (doc) => this._handleAudienceVoteIdeaEvent(editor, doc))
    Socket.getSocket().on('add-slides', (doc) => this._handleAddSlides(editor, doc))
    Socket.getSocket().on('conversation-presenter-share', (doc) => this._handleCommentPresentation(editor, doc))
    if (!store.getters['liveStatsV2/canUseReactionEmqx']) {
      Socket.on(CREATE_REACTION, (doc) => this._handleCreateReaction(editor, doc))
    }
    Socket.on('patch-presentation', (doc) => this._handlePatchPresentation(editor, doc))
  },

  _handleAudienceCreateIdeaEvent(editor, doc) {
    // editor._checkAndUpdateHasResults()
    const matchSlide = editor.presentation.slides.find((slide) => slide.id === doc.slideId)

    if (!matchSlide
      || !matchSlide.SlideOptions
      || matchSlide.SlideOptions.length >= Constants.MAX_IDEAS_NUMBER) {
      return
    }

    let newSlideOptions = [...editor.slideActive.SlideOptions, doc]
    newSlideOptions = newSlideOptions
      .map((idea, index) => ({ ...idea, createdAtOrder: index + 1 }))

    editor.patchSlideByIdAction({
      id: doc.slideId,
      SlideOptions: newSlideOptions,
    })

    if (doc.slideId === editor.slideActive.id) {
      EventBus.$emit('handleSortIdeasByCreatedAt')
    }

    EventBus.$emit('handleScrollingAndShowScroll')
  },

  _handleAudienceVoteIdeaEvent: _.throttle((editor, doc) => {
    const index = editor.slideActive.SlideOptions.findIndex((option) => {
      return option.id === doc.slideOptionId
    })
    if (index === -1) return
    editor.slideActive.SlideOptions[index].votesCount = doc.numberOfVotes
    editor.updateSlideActiveAction(editor.slideActive)
  }, 300),

  _handleAddSlides(editor, payload) {
    const slideTypes = {}
    Constants.allTypeSections.forEach((item) => {
      item.slideTypes.forEach((typeObj) => {
        slideTypes[typeObj.type] = typeObj
      })
    })

    payload.slides.forEach((item) => {
      if (item.type) {
        item.typeObj = slideTypes[item.type]
      }
    })

    editor.$store.state.presentation.slides = editor.$store.state.presentation.slides.concat(
      payload.slides,
    )
  },

  _handleCreateReaction: _.throttle((editor, message) => {
    const { audienceName, reactionType, ...partialPresentation } = message
    editor.patchPresentationAction(partialPresentation)
    EventBus.$emit(CREATE_REACTION, { audienceName, reactionType })
  }, 200),

  _handlePatchPresentation(editor, payload) {
    // Reactions already set state, set again will results in flickering
    // https://ahaslides.atlassian.net/browse/AHA-7788
    if (payload.reactions) return
    editor.patchPresentationAction(payload)
  },

  async _handleCommentPresentation(editor, doc) {
    if (doc.type === 'new-message' && doc.data.socketId !== Socket.getSocketId()) {
      EventBus.$emit('presentation-new-comment', doc.data)
    }
  },
}
